import ProgRing from "../shared-ui-components/ProgRing";
import "./AnalysisList.scss";
import { formatDate } from "../util/general";

export type AnalysisItem = {
  analysisId: string;
  name: string;
  fileType: string;
  color: string;
  status: string;
  rating: number;
  timestamp: string;
  scantime: string;
  size: string;
  isFavorite: boolean;
  isPublic: boolean;
};

interface AnalysisListProps {
  items: AnalysisItem[];
  onFavoriteToggle: (e: React.MouseEvent, analysisId: string) => void;
  onItemClick: (analysisId: string) => void;
  showVisibilityToggle?: boolean;
  visibilityLoading?: Set<string>;
  onVisibilityToggle?: (
    e: React.MouseEvent,
    analysisId: string,
    currentIsPublic: boolean,
  ) => void;
}

export default function AnalysisList({
  items,
  onFavoriteToggle,
  onItemClick,
  showVisibilityToggle = false,
  visibilityLoading = new Set(),
  onVisibilityToggle,
}: AnalysisListProps) {
  return (
    <div className="sample-container">
      <div
        className={`sample-titles${showVisibilityToggle ? " my-uploads" : ""}`}
      >
        {showVisibilityToggle && <span />}
        <span>Status</span>
        <span>Filename</span>
        <span>Type</span>
        <span>Scan Time</span>
        <span>Time Stamp</span>
        <span>Size</span>
      </div>
      {items.map((item) => {
        const isVisibilityLoading = visibilityLoading.has(item.analysisId);
        return (
          <div
            className={`sample-item${showVisibilityToggle ? " my-uploads" : ""} ${item.color}`}
            key={item.analysisId}
            onClick={() => onItemClick(item.analysisId)}
          >
            {showVisibilityToggle ? (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div>
                  <button
                    className={`favorite-btn ${item.isFavorite ? "favorited" : ""}`}
                    onClick={(e) => onFavoriteToggle(e, item.analysisId)}
                    title={
                      item.isFavorite
                        ? "Remove from favorites"
                        : "Add to favorites"
                    }
                    aria-label={
                      item.isFavorite
                        ? "Remove from favorites"
                        : "Add to favorites"
                    }
                  >
                    <i
                      className={
                        item.isFavorite ? "fas fa-heart" : "far fa-heart"
                      }
                    />
                  </button>
                  <button
                    className={`visibility-toggle-btn ${item.isPublic ? "public" : "private"}`}
                    onClick={(e) =>
                      onVisibilityToggle?.(e, item.analysisId, item.isPublic)
                    }
                    disabled={isVisibilityLoading}
                    title={item.isPublic ? "Make private" : "Make public"}
                    aria-label={item.isPublic ? "Make private" : "Make public"}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      cursor: "pointer",
                    }}
                  >
                    <span style={{ fontSize: 18 }}>
                      {item.isPublic ? "\uD83D\uDD13" : "\uD83D\uDD12"}
                    </span>
                    <span style={{ fontSize: 12, color: "#888" }}>
                      {item.isPublic ? "Public" : "Private"}
                    </span>
                  </button>
                </div>
              </div>
            ) : (
              <button
                className={`favorite-btn ${item.isFavorite ? "favorited" : ""}`}
                onClick={(e) => onFavoriteToggle(e, item.analysisId)}
                title={
                  item.isFavorite ? "Remove from favorites" : "Add to favorites"
                }
                aria-label={
                  item.isFavorite ? "Remove from favorites" : "Add to favorites"
                }
              >
                <i
                  className={item.isFavorite ? "fas fa-heart" : "far fa-heart"}
                />
              </button>
            )}

            <div className={`risk-rating-gauge-sample ${item.color}`}>
              <ProgRing value={item.rating ?? 0} /> {item.status}
            </div>

            <span className="sample-name" data-label="Filename">
              {item.name}
            </span>
            <span className="sample-type" data-label="Type">
              {item.fileType}
            </span>
            <span className="sample-scantime" data-label="Scan Time">
              {item.scantime}
            </span>
            <span className="sample-timestamp" data-label="Time Stamp">
              {formatDate(item.timestamp)}
            </span>
            <span className="sample-size" data-label="Size">
              {item.size}
            </span>
          </div>
        );
      })}
    </div>
  );
}
